import React, {useCallback, useMemo, useState} from "react";
import {array, bool, object, oneOfType, string, func} from "prop-types";
import "./index.scss";
import Text from "features/components/text";
import Button from "features/components/button";
import {__} from "services/i18n";
import {generateFullUrl} from "services/utils/utils";
import {Icon} from "features/components/icon";

const DocumentLoader = (props) => {
    const {vertical, text, buttonTitle, accept = [], onChange, value, disabled} = props;
    const [imageSrc, setImageSrc] = useState(value);
    const input = React.useRef(null);
    const openFileSelect = useCallback(() => {
        input.current.click();
    }, [input]);
    const fileSelected = useCallback((event) => {
        const file = event.target.files[0];
        if (!file) {
            return;
        }
        const reader = new FileReader();
        reader.readAsDataURL(file);
        /* istanbul ignore next */
        reader.onload = (event) => {
            setImageSrc(event.target.result);
            onChange({
                name: file.name,
                type: file.type,
                src: event.target.result
            })
        }
    }, [onChange]);

    const isImage = useMemo(() => {
        return accept.map(i => i.indexOf("image") > -1).filter(i => !!i).length > 0;
    }, [accept]);

    const imageSource = useMemo(() => {
        if (!imageSrc) {
            return null
        }
        return imageSrc.src || generateFullUrl(imageSrc);
    }, [imageSrc]);

    const renderAssociatedDocument = useMemo(() => {
        if(typeof value === "string") {
            return <div className={"attachment-selected-document-loader"}>
                <a href={generateFullUrl(value)} target={"_blank"} rel={"noopener noreferrer"}><Text size={16}>Vedi documento associato</Text></a>
            </div>
        }

        return  <div className={"attachment-selected-document-loader"}>
            <div onClick={() => onChange(null)}><Icon>close</Icon></div>
            <Text size={16}>{value?.name}</Text>
        </div>
    }, [value, onChange]);

    return <div>
        <div className={`document-loader ${!!vertical ? "vertical" : "horizontal"} ${isImage ? "isImage": "isDocument"}`}>
            <input type="file"
                   accept={accept}
                   ref={input}
                   className="file-upload"
                   onChange={fileSelected}
            />
            <div className={`image ${(!isImage || !imageSource) ? "has-bg" : ""}`}>
                {isImage && !!imageSource && <img src={imageSource} alt={"preview"}/>}
            </div>
            <div className="data">
                <Text size={16}>{text}</Text>
                <Button disabled={!!disabled} title={buttonTitle || __("buttons.upload")} onClick={openFileSelect} type={"clear"} size={"small"} />
            </div>
        </div>
        {(!isImage && value) && renderAssociatedDocument}
    </div>
};

DocumentLoader.propTypes = {
    vertical: bool,
    text: oneOfType([string, object]),
    buttonTitle: oneOfType([string, object]),
    accept: array,
    onChange: func.isRequired,
    value: oneOfType([string, object]),
    disabled: bool
};

export default DocumentLoader;